import type { PopupConfigRequest } from '../types/popupDetail';

/**
 * 직원확인 비밀번호 설정의 폼 입력 → config 페이로드(PopupConfigRequest 부분) 변환.
 *
 * 비밀번호 단위는 팝업 전체 단일(회차/슬롯 공통). 평문으로 전송하고 BE 가 BCrypt 해시한다.
 * 규칙(★보안: 빈 문자열 전송 금지 — 기존 해시 보존을 위해 미변경은 항상 키 생략):
 *  - 토글 OFF: `staffEntryPasswordEnabled: false` 만 전송 → BE 가 해시를 비활성/해제([직원확인] 단독 입장).
 *  - 토글 ON  + 비번 입력 있음: `enabled: true` + `staffEntryPassword`(평문) 전송 → BE 해시 갱신.
 *  - 토글 ON  + 비번 입력 없음: `enabled: true` 만 전송(비번 키 생략) → 기존 해시 보존(미변경).
 *
 * @param enabled  '직원확인 비밀번호 활성화' 토글 상태.
 * @param password 비밀번호 입력값(평문). 공백만/빈 값은 미입력으로 본다.
 */
export const buildStaffEntryConfigPayload = (
  enabled: boolean,
  password: string,
): Pick<PopupConfigRequest, 'staffEntryPasswordEnabled' | 'staffEntryPassword'> => {
  if (!enabled) {
    // OFF: 비번 키는 보내지 않는다(BE 는 enabled=false 로 해시를 비활성/해제).
    return { staffEntryPasswordEnabled: false };
  }
  const trimmed = password.trim();
  return trimmed
    ? { staffEntryPasswordEnabled: true, staffEntryPassword: trimmed }
    : { staffEntryPasswordEnabled: true };
};
